import type { ScreenState } from './ScreenState';

export const isEmptySubtype = (state: ScreenState): boolean => {
	return 'currentViewSubtype' in state && state.currentViewSubtype === 'empty';
};
